import { render } from "./FilterUserByVendorMapping.vue?vue&type=template&id=5734e2a3"
import script from "./FilterUserByVendorMapping.vue?vue&type=script&lang=js"
export * from "./FilterUserByVendorMapping.vue?vue&type=script&lang=js"
script.render = render

export default script